/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Image, Table } from 'react-bootstrap';
import { toHeaderCase, toLowerCase } from 'js-convert-case';

import '../../../flag-icons/css/flag-icons.min.css';

const lookup = require('country-code-lookup');

export interface ITableCompProps {
  headers: string[];
  rowValues: any[];
}

export const TableComp = ({ headers, rowValues }: ITableCompProps) => {
  const _checkValueIs = (country: string) => {
    return lookup.byCountry(country)?.internet;
  };
  const TableRow = (props: any) => {
    const _props: any = [];
    if (props) {
      for (const [key, value] of Object.entries(props)) {
        _props.push({
          key,
          value,
        });
      }
    }
    return (
      <tr>
        {_props.map((data: any, index: any) => {
          let country = _checkValueIs(data?.value);
          return (
            <td key={`ranking-table-td-${index}`} className="fw-bold border-0">
              {country && (
                <span class={`fi fi-${toLowerCase(country)} fis`}></span>
              )}{' '}
              {data.value}
            </td>
          );
        })}
      </tr>
    );
  };
  return (
    <>
      <Card border="0" className="shadow">
        <Card.Body>
          <Table
            responsive
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                {headers?.map((header, index) => {
                  let className = 'border-0';
                  if (index === 0) {
                    className = `${className} rounded-start`;
                  }
                  if (index === headers?.length - 1) {
                    className = `${className} rounded-end`;
                  }
                  return (
                    <th key={`ranking-table-${index}`} className={className}>
                      {toHeaderCase(header)}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="border-0">
              {rowValues.map((r) => (
                <TableRow key={`ranking-${r.id}`} {...r} />
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
};

TableComp.defaultProps = {
  headers: [],
  rowValues: [],
};
